// Nyelv-zászló — a kétnyelvű űrlap-mezők nyelv-jelölője. A `lang` a MEZŐ nyelve ('hu'→magyar zászló,
// 'en'→brit zászló). Két mód:
//  • alap (címke MELLÉ): a zászló-SVG DEKORATÍV (`aria-hidden`), MELLÉ egy `sr-only` span hordozza a
//    lokalizált nyelv-toldalékot → a képernyőolvasó a mező akadálymentes nevében megkapja a nyelvet.
//  • `decorative` (a mezőBEN, „zászló a mezőben" minta — lásd BilingualField): tisztán vizuális, NINCS
//    sr-only szöveg → a zászló NEM ad hozzá az akadálymentes névhez (azt a kontroll `aria-label`-je viszi).
// A `common.langSuffix.{hu,en}` kulcs a MEZŐ nyelvét jelöli (nem a UI-nyelvet). Zászló-forrás:
// country-flag-icons (hu→HU, en→GB/Union Jack).
import GB from 'country-flag-icons/react/3x2/GB';
import HU from 'country-flag-icons/react/3x2/HU';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

const FLAGS = { hu: HU, en: GB } as const;

/** Kicsi nyelv-zászló. `decorative` → tisztán vizuális (nincs sr-only nyelv-toldalék); alapból a toldalékot
 *  sr-only span hordozza. A `lang` a MEZŐ nyelve ('hu'→magyar zászló, 'en'→brit zászló). */
export function LangFlag({
  lang,
  className,
  decorative = false,
}: {
  lang: 'hu' | 'en';
  className?: string;
  /** Ha true, a zászló tisztán dekoratív (nincs sr-only nyelv-toldalék) — a mezőBEN használt adornmenthez. */
  decorative?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const Flag = FLAGS[lang];
  return (
    <span className={cn('inline-flex items-center align-middle', className)}>
      <Flag aria-hidden className="h-3 w-[1.125rem] rounded-[1px] ring-1 ring-black/10" />
      {!decorative && <span className="sr-only">{t(`common.langSuffix.${lang}`)}</span>}
    </span>
  );
}
